export const SERVER_DOMAIN =
  window.location.origin.includes("localhost") ||
  window.location.origin.includes("169.254")
    ? "https://staging.uplin.com/"
    : window.location.origin + "/";
